import { createSlice } from "@reduxjs/toolkit"

const INITIAL_STATE = {
  cvs: null,
  pendingCVs: [],
  cvsFiles: [],
  pagination: {
    total: 0,
    limit: 25,
    offset: 0,
    hasMore: false
  },
  search: {
    keyword: "",
    selectedLabels: [],
    uploadDate: {
      from: "",
      to: "",
    },
    occupation: {
      activitySector: [],
      occupation: []
    },
    location: {
      country: [],
      city: [],
    },
    skills: {
      softSkills: [],
      hardSkills: [],
    }
  },
  labels: null,
}
const cvSlice = createSlice({
  name: "cv",
  initialState: INITIAL_STATE,
  reducers: {
    reset: (state) => {
      state = INITIAL_STATE
    },
    resetCVs: (state) => {
      state.cvs = null
    },
    setCvs: (state, action) => {
      state.cvs = action.payload
    },

    setPagination: (state, action) => {
      state.pagination = action.payload;
    },

    setLabels: (state, action) => {
      state.labels = action.payload;
    },

    updatePagination: (state, action) => {
      state.pagination = {
        ...state.pagination,
        ...action.payload,
      }
    },

    setSearch: (state, action) => {
      state.search = action.payload
    },

    updateSearch: (state, action) => {
      state.search = {
        ...state.search,
        ...action.payload,
      }
    },

    resetSearch: (state) => {
      state.search = {
        ...INITIAL_STATE.search
      }
    },

    setPendingCVs: (state, action) => {
      state.pendingCVs = action.payload
    },

    addCVFile: (state, action) => {
      state.cvsFiles = {
        ...state.cvsFiles,
        [action.payload.id]: action.payload.url,
      }
    },

    addPendingCVs: (state, action) => {
      state.pendingCVs = [
        ...state.pendingCVs,
        ...action.payload.map(({ cvId, file_name, source }) => ({
          id: cvId,
          information: {
            file_name: file_name,
          },
          status: "IN_PROGRESS",
          // Optional — set to "sourcing" by the SourcingPage so CVItem can
          // render a "Sourced" tag while parsing is still in progress.
          ...(source ? { source } : {}),
        })),
      ]
    },
  },
})

export const { reset, resetCVs, setCvs, setPagination, setLabels, updatePagination, setSearch, updateSearch, resetSearch, addCVFile, addPendingCVs, setPendingCVs } = cvSlice.actions

export default cvSlice.reducer